import { Button, Carousel, List, Skeleton } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { NEWS, NEWS_CATEGORY } from '../../constants/Url';
// import { useNavigate } from 'react-router';
import { antdResponsive, objectToQuery, showFormatDate } from '../../utils/Utils';
import TextScroll, { TextScrolls } from '../../components/TextScroll';
import CustomPagination from '../../components/common/CustomPagination';
import { useTranslation } from 'react-i18next';
import httpClient from '../../utils/HttpClient';
import { debounce } from 'lodash';
import AppDownloadModal from '../../components/AppDownloadModal';
import { useSelector } from 'react-redux';
import AuthModal from '../../components/auth/AuthModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setBlogFeatureAction } from '../../modules/dataWebsite/actions';
import PROModal from '../../components/PROModal';
import { useMemberAccess } from '../../hooks/useMemberAccess';

export default function NewsPage() {
    const [searchParams] = useSearchParams();
    const tag = searchParams.get('tag');
    const navigate = useNavigate();
    const authModalRef = useRef()
    const user = useSelector((state) => state.authReducer);
    const { hasNoActiveMembership } = useMemberAccess();
    let token = user && user?.token ? user?.token : null
    const appDownloadRef = useRef();
    const [isMemberGateOpen, setIsMemberGateOpen] = useState(false);
    const { t } = useTranslation();
    const [selectedCategory, setSelectedCategory] = useState(tag || "");
    const blogFeatureData = useSelector((state) => state.dataWebsiteReducer?.blogFeatureData);

    useEffect(() => {
        if (tag) {
            navigate("/news", { replace: true });
        }
    }, [tag, navigate]);
    const [total, setTotal] = useState(0);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [categoryLoading, setCategoryLoading] = useState(true);
    const [blogLoading, setBlogLoading] = useState(true);
    const [blogMainLoading, setBlogMainLoading] = useState(true);
    const [blogs, setBlogs] = useState([
        // DO NOT REMOVE THIS COMMENT
        // TO KEEP TRACK OF THE DATA STRUCTURE
        // {
        //     coverimage: "",
        //     title: "",
        //     subtitle: "",
        //     category: "",
        //     createdAt: "",
        // }
    ]);
    const [blogMain, setBlogMain] = useState([
        // DO NOT REMOVE THIS COMMENT
        // TO KEEP TRACK OF THE DATA STRUCTURE
        // {
        //     coverimage: "",
        //     title: "",
        //     subtitle: "",
        //     category: "",
        //     createdAt: "",
        // }
    ]);
    const [category, setCategory] = useState([
        // DO NOT REMOVE THIS COMMENT
        // TO KEEP TRACK OF THE DATA STRUCTURE
        // {
        //     name: "",
        //     _id: "",
        // }
    ]);

    const fetchBlog = async (query) => {
        setBlogLoading(true);
        try {
            const res = await httpClient.get(objectToQuery(NEWS, query ?? { pageNo, pageSize, category: selectedCategory }))
                .then(res => res.data)
                .catch(error => ({ status: 500, message: error?.message }));

            if (res.status === 200) {
                setBlogs([...res.data])
                setTotal(res.total);
            } else {
                setBlogs([]);
            }
        } catch (error) {
            console.error("fetchData -> error", error)
        } finally {
            setBlogLoading(false);
        }
    }

    const fetchBlogFeature = async (query) => {
        try {
            const res = await httpClient.get(objectToQuery(NEWS, 
                {
                    // pageNo,
                    // pageSize,
                    // category: selectedCategory,
                    pageSizeNo: true,
                    isFeature: true
                }
            ))
                .then(res => res.data)
                .catch(error => ({ status: 500, message: error?.message }));

            if (res.status === 200) {
                setBlogFeatureAction(res?.data ? res.data : [])
            } else {
                setBlogFeatureAction([]);
            }
        } catch (error) {
            console.error("error", error)
        } finally {
        }
    }
    useEffect(() => {
        fetchBlogFeature();
    }, []);

    const fetchCategories = async () => {
        setCategoryLoading(true);
        try {
            const res = await httpClient.get(NEWS_CATEGORY)
                .then(res => res.data)
                .catch(error => ({ status: 500, message: error?.message }));

            if (res.status === 200) {
                setCategory([...res.data])
            } else {
                setCategory([]);
            }
        } catch (error) {
            console.error("fetchData -> error", error)
        } finally {
            setCategoryLoading(false);
        }
    }

    const fetchMainBlog = async () => {
        setBlogMainLoading(true);
        try {
            const res = await httpClient.get(objectToQuery(NEWS, { pageNo: 1, pageSize: 10, isFeature: true }))
                .then(res => res.data)
                .catch(error => ({ status: 500, message: error?.message }));

            if (res.status === 200) {
                setBlogMain([...(res?.data || [])])
            } else {
                setBlogMain([]);
            }
        } catch (error) {
            console.error("fetchData -> error", error)
        } finally {
            setBlogMainLoading(false);
        }
    }

    const handleChangeCategory = (item) => {
        if (item._id === "") {
            setSelectedCategory("");
        } else {
            setSelectedCategory(item.name === selectedCategory ? "" : item.name);
        }
        setPageNo(1);
        setPageSize(10);
    }

    const openDownloadAppModal = (item) => {
        if (token) {
            if (!user?.user?.completedTS) {
                authModalRef.current.open("REGISTER");
            } else if (hasNoActiveMembership()) {
                // Has account but no active membership → show subscription modal
                setIsMemberGateOpen(true);
            } else {
                navigate(`/news/${item?.newsId}`);
            }
        } else {
            authModalRef.current.open();
        }
    }

    const debouncedFetchAll = useCallback(
        debounce(async () => {
            await Promise.all([fetchCategories(), fetchMainBlog()])
        }, 300),
        []
    );

    const debouncedFetchBlogCallback = useCallback(
        debounce(() => fetchBlog({ pageNo, pageSize, category: selectedCategory }), 300),
        [pageNo, pageSize, selectedCategory]
    );

    useEffect(() => {
        debouncedFetchBlogCallback();
        // Cleanup to cancel debounce on unmount or dependency change
        return debouncedFetchBlogCallback.cancel;
    }, [debouncedFetchBlogCallback])

    useEffect(() => {
        debouncedFetchAll();
        // Cleanup to cancel debounce on unmount or dependency change
        return debouncedFetchAll.cancel;
    }, [debouncedFetchAll])

    return (
        <div className='esi-std-container full-flex'>
            <AuthModal ref={authModalRef} />
            <PROModal open={isMemberGateOpen} onCancel={() => setIsMemberGateOpen(false)} /> 
            {(blogMainLoading || blogMain.length > 0) && (
                <Carousel
                    className='esi-std-white-space esi-news-main-carousel'
                    responsive={antdResponsive({
                        xxs: {
                            slidesToShow: 1,
                        },
                        sm: {
                            slidesToShow: 2,
                        },
                    })}
                    slidesToShow={3}
                    draggable
                    autoplay
                    slidesToScroll={1}
                    dots={false}
                    swipeToSlide
                >
                    {
                        blogMainLoading && Array(4).fill(0).map((item, index) => {
                            return <div key={index} className='cursor-pointer select-none esi-news-card'>
                                <div className='overflow-hidden max-sm:rounded-[1rem]'>
                                    <Skeleton.Image rootClassName='esi-news-card-image' className='esi-news-card-image' active={true} />
                                </div>
                                <div className='text-start w-full text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3 line-clamp-2'>
                                    <Skeleton.Input active block />
                                    <Skeleton.Input active block />
                                </div>
                            </div>
                        })
                    }
                    {
                        !blogMainLoading && blogMain.map((item, index) => {
                            return <div key={item._id || item.newsId || index} className='cursor-pointer select-none esi-news-card' onClick={() => openDownloadAppModal(item)}>
                                <div className='overflow-hidden max-sm:rounded-[1rem]'>
                                    <img className='esi-news-card-image' src={item.coverimage} alt={item.title} />
                                </div>
                                <div className="text-start text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3 line-clamp-2">
                                    {item.title}
                                </div>
                            </div>;
                        })
                    }
                </Carousel>
            )}
            {/*
            {blogFeatureData?.length ? <TextScroll textButton={t('menu_headline')}
            content={blogFeatureData?.length ? blogFeatureData.map(it => it?.title) : []}
             /> : ""} */}
            {blogFeatureData?.length ? <TextScrolls textButton={t('menu_headline')}
            contents={blogFeatureData?.length ? blogFeatureData : []}
            onClickItem={(item) => openDownloadAppModal(item)}
             /> : ""}
            <div className="esi-std-white-space flex flex-col md:flex-row md:items-center md:justify-between gap-3 border-b border-gray-200 pb-3">
                {/* Title */}
                <div className="text-xl md:text-2xl font-bold">
                    {t("menu_news")}
                </div>

                {/* Categories */}
                <div className="flex items-center gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden whitespace-nowrap scrollbar-hide">
                    {categoryLoading
                        ? Array(4)
                            .fill(0)
                            .map((_, i) => (
                                <Skeleton.Button
                                    key={i}
                                    style={{ width: 64, height: 32 }}
                                    active
                                    shape="square"
                                />
                            ))
                        : [{ name: "全部", _id: "" }, ...category].map((item) => {
                            const isActive =
                                selectedCategory === item.name ||
                                (item._id === "" && selectedCategory === "");

                            return (
                                <button
                                    key={item._id || "all"}
                                    onClick={() => handleChangeCategory(item)}
                                    className={`relative px-3 py-2 text-sm transition-colors whitespace-nowrap
                              ${isActive
                                            ? "font-bold text-black"
                                            : "font-medium text-gray-500"
                                        }`}
                                >
                                    {item.name}

                                    {isActive && (
                                        <span
                                            className="absolute left-3 right-3 bottom-0 h-[3px] rounded-full"
                                            style={{
                                                background:"linear-gradient(to right, #50c7f8, #7887fd, #df97fb)",
                                            }}
                                        />
                                    )}
                                </button>
                            );
                        })}
                </div>
            </div>

            <div className='full-flex'>
                <List
                    className="mt-4 full-flex"
                    rootClassName='loading-full-flex'
                    style={{marginTop:"1rem"}}
                    grid={{
                        gutter: { xs: 10, md: 20, lg: 30 },
                        xs: 1,
                        sm: 1,
                        md: 1,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}
                    pagination={false}
                    dataSource={blogLoading ? Array(6).fill(0) : blogs}
                    renderItem={(item) => (
                        blogLoading ?
                            <List.Item>
                                <div className="grid grid-cols-7 cursor-pointer select-none">
                                    <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                        <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                                    </div>
                                    <div className='col-span-4 px-3 flex flex-col justify-between'>
                                        <div className='flex flex-col gap-1'>
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />

                                            <Skeleton.Input
                                                rootClassName='max-sm:!hidden md:!block'
                                                className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                        </div>
                                        <div className='mt-3 lg:mt-0 gap-3 flex justify-between items-center'>
                                            <Skeleton.Button className='esi-secondary-button' active shape={'square'} />
                                            <div className='esi-news-card-dob w-full'>
                                                <Skeleton.Input rootClassName='esi-input-skeleton' active />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </List.Item>
                            :
                            <List.Item>
                                <div className="grid grid-cols-7 cursor-pointer select-none" onClick={() => openDownloadAppModal(item)}>
                                    <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                        <img className="esi-sub-news-card-image" style={{ cursor: "pointer" }} src={item.coverimage} alt={item.title} />
                                    </div>
                                    <div className='col-span-4 px-3 flex flex-col justify-between'>
                                        <div className='flex flex-col gap-1'>
                                            <div className="esi-news-card-title max-w-[100%] line-clamp-1 xl:line-clamp-2">{item.title}</div>
                                            <div className="esi-news-card-description max-w-[100%] line-clamp-2 xl:line-clamp-3">{item.subtitle}</div>
                                        </div>
                                        <div className='mt-3 lg:mt-0 flex justify-between items-center'>
                                            <div className='gradient-text-button'>{item.category}</div>
                                            <div className='esi-news-card-dob'>{showFormatDate(item.createdAt)}</div>
                                        </div>
                                    </div>
                                </div>
                            </List.Item>
                    )}
                ></List>
                
                {/* Custom Pagination Component */}
                {total > 0 && (
                    <div className="flex justify-end mt-12 w-full">
                        <CustomPagination
                            current={pageNo}
                            pageSize={pageSize}
                            total={total}
                            onChange={(page, limit) => {
                                if (limit !== pageSize) {
                                    setPageSize(limit);
                                    setPageNo(1);
                                } else {
                                    setPageNo(page);
                                }
                            }}
                            pageSizeOptions={[10, 20, 30, 40, 50]}
                        />
                    </div>
                )}
            </div>

            <div className='h-[40px]'></div>

            {/* <AppDownloadModal ref={appDownloadRef} /> */}
        </div>
    )
}
